import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DiscountListLayer from "../../components/ManageDiscount/DiscountList";

const DiscountList = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Discount Management"  />

        <DiscountListLayer />
      </MasterLayout>
    </>
  );
};

export default DiscountList;
